module.exports = __webpack_public_path__ + "static/img/icon2.6796e464.svg";